<template>
  <div class="soar-container flex flex-col gap-y-4">
    <SearchPanel></SearchPanel>
    <DashboardControlpanel class="pt-4"></DashboardControlpanel>
    <ServicesOverview></ServicesOverview>
    <div class="w-full flex flex-col md:flex-row justify-between items-center gap-4">
      <CollapsibleSection :header-label="$t('CreateSponsorFile')" class="w-full md:w-1/3">
        <div class="flex flex-col gap-y-2">
          <RouterLink
            :key="key"
            :to="link.to"
            v-for="(link, key) in createSponsorFileItems"
            class="flex justify-between gap-x-8 ltr:font-sans text-xs hover:text-primary"
          >
            <span>{{ $t(link.label) }}</span>
            <faChevronRight class="w-2 fill-primary" />
          </RouterLink>
        </div>
      </CollapsibleSection>
      <div class="flex gap-x-3">
        <RouterLink
          :to="{ name: 'OneclickServices' }"
          class="flex justify-between items-center gap-x-3 ltr:font-sans text-xs hover:text-primary"
        >
          <span>{{ $t('oneClickServices') }}</span>
          <faChevronRight class="w-2 fill-primary" />
        </RouterLink>
        <i class="ica-custom-fonts-quick-services text-primary text-8xl"></i>
      </div>
    </div>
    <BrowseSmartServices></BrowseSmartServices>
    <Teleport to="#appBody">
      <div class="fixed top-1/2 end-0 z-40">
        <RouterLink
          :to="{ name: 'IndMyCompanies' }"
          v-tippy="{ content: $t('myCompanies'), placement: 'left' }"
          class="size-9 flex justify-center items-center bg-primary hover:shadow-lg"
        >
          <faBuilding class="w-4 fill-white" />
        </RouterLink>
      </div>
    </Teleport>
  </div>
</template>

<script setup>
import SearchPanel from '@/views/individual/dashboard/SearchPanel/index.vue'
import { useAuthStore } from '@/stores/auth'
import DashboardControlpanel from '@/views/individual/dashboard/ControlPanel.vue'
import ServicesOverview from '@/views/individual/dashboard/ServicesOverview/index.vue'
import BrowseSmartServices from '@/views/individual/dashboard/SmartServices/index.vue'
import CollapsibleSection from '@/components/Ui/CollapsibleSection.vue'
import faChevronRight from '@/assets/icons/faChevronRight.svg?component'
import faBuilding from '@/assets/icons/faBuilding.svg?component'
import { onMounted, nextTick } from 'vue'

const authStore = useAuthStore()

onMounted(async () => {
  await nextTick()
  await authStore.getProfile()
  await authStore.fetchIndividualInfo()
})

const createSponsorFileItems = [
  {
    to: {
      name: 'ServiceForm',
      params: {
        serviceId: 411
      }
    },
    label: 'CreateSponsorFileLocalOrGcc'
  },
  {
    to: {
      name: 'ServiceForm',
      params: {
        serviceId: 434
      }
    },
    label: 'CreateSponsorFileEstate'
  },
  {
    to: {
      name: 'ServiceForm',
      params: {
        serviceId: 435
      }
    },
    label: 'CreateSponsorFileFarm'
  }
]
</script>

<script>
export default { name: 'IndLanding' }
</script>

<style lang="scss" scoped></style>
